const common = {
  'common.add': 'Add',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.start': 'Start',
  'common.save': 'Save',
  'common.saveAs': 'Save As',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.search': 'Search...',
  'common.search.type': 'กรอกค้นหา',
  'common.reset': 'Reset',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.ok': 'OK',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.submit': 'Submit',
  'common.finish': 'Job Close',
  'common.print': 'Print',
  'common.stickerPrint': 'Sticker Print',
  'common.createdCutting': 'Cutting Confirm',
  'common.update': 'Update',
  'common.export': 'Export',
  'common.upload': 'Upload',
  'common.message': 'Message',
  'common.revert': 'Revert',
  'common.dateRange': 'Date Range',

  'common.confirm': 'Confirm',
  'common.confirmPrint': 'Task Print',

  'common.error': 'Error',

  'common.success': 'Success',

  'common.warning': 'Warning',
  'common.add-btn-warning': 'Add Warning',

  'common.info': 'Info',

  'common.items': 'Items',
  'common.count-items': '{count} items',
  'common.display-count': 'Display count',
  'common.no-data': 'No Data',

  'common.date.day': 'Day',
  'common.date.month': 'Month',
  'common.date.year': 'Year',

  'common.active': 'Active',
  'common.inactive': 'Inactive',

  'common.verify': 'Verify',
  'common.unverify': 'No verify',

  'common.select-placeholder': 'Select...', // Deprecated
  'common.select.placeholder': 'Select...',
  'common.select.loading': 'Loading...',
  'common.select.empty': 'No options',
  'common.valid': 'Valid',
  'common.invalid': 'Invalid',

  'common.saveCustomer': 'Save Fragment',
  'common.placeholder.matching': ' by product name',
  'common.placeholder.receiving': ' by po no.',
  'common.placeholder.company': ' by company name',
  'common.placeholder.machine': ' by machine name',
  'common.placeholder.tooling': ' by tooling name',
  'common.placeholder.supplier': ' by supplier name',
  'common.placeholder.employees': ' by employee name',
  'common.placeholder.customer': ' by customer name',
  'common.placeholder.rm': ' by rm name',
  'common.placeholder.bom': ' by bom name',
  'common.placeholder.user': ' by name',
  'common.placeholder.store': ' by store code ',
  'common.placeholder.message': 'search by detail',

  'common.submit.confirm-text': 'Confirm to submit operation data or not?',
  'common.delete.confirm': 'Are you sure to delete this item?',
  'common.save.success': 'Save successfully',
  'common.delete.success': 'Delete successfully',

  'common.field.code': 'Code',

  'common.unit.piece': 'Piece',
  'common.search.inventory': ' by material name.',
  'common.search.productInventory': ' by name.',
  'common.search.movement': ' by material code.',
  'common.search.outsource': ' by code',
  'common.search.salesOrder': ' by customer name.',
  'common.search.customerOrder': ' by customer name.',
  'common.search.cuttingList': 'Search by product name.',
  'common.search.materialMatching': ' by product name ',
  'common.search.product': ' by product name.',
  'common.search.sticker': ' by product name.',
  'common.search.export': ' by time schedule',
  'common.kspRm': 'KSP RM',
  'common.kspProduct': 'KSP Product',
  'common.kspSupplier': 'Supplier',
  'common.productForSale': 'Product for sale',
};

const dashboards = {
  'dashboards.title': 'แดชบอร์ด',
};

const payment = {
  'payment.title': 'Payment',

  'payment.field.no': 'No',
  'payment.field.bill': 'Bill No.',
  'payment.field.payNo': 'Payment No.',
  'payment.field.name': 'Name',
  'payment.field.phone': 'Phone',
  'payment.field.address': 'Address',
  'payment.field.amount': 'Amount (LAK)',
  'payment.field.status': 'Status',
  'payment.field.createAt': 'Create Date',
  'payment.field.updateAt': 'Update Data',

  'payment.field.shipping': 'Shipping',
  'payment.field.search': 'Search (Phone number)',
  'payment.field.info': 'Customer Information',

  'payment.field.parcel-title': 'Parcel Item',
  'payment.field.parcel-track-no': 'Parcel Item',
  'payment.field.parcel-weight': 'Weight',
  'payment.field.parcel-price': 'Price (LAK)',
  'payment.field.receipt': 'Receipt date',
  'payment.field.importDate': 'Import date',
  'payment.field.shippingDate': 'Shipping date',
};

const bill = {
  'bill.title': 'Bill',

  'bill.field.no': 'No',
  'bill.field.create': 'Create Bill',
  'bill.field.bill': 'Bill No.',
  'bill.field.payNo': 'Payment No.',
  'bill.field.name': 'Name',
  'bill.field.phone': 'Phone',
  'bill.field.address': 'Address',
  'bill.field.amount': 'Amount (LAK)',
  'bill.field.status': 'Status',
  'bill.field.importAt': 'Import Date',
  'bill.field.createAt': 'Create Date',
  'bill.field.updateAt': 'Update Data',

  'bill.field.add': 'Add',
  'bill.field.shipping': 'Shipping',
  'bill.field.search': 'Search (Phone number)',
  'bill.field.info': 'Customer Information',

  'bill.field.parcel-title': 'Parcel Item',
  'bill.field.parcel-track-no': 'Parcel Item',
  'bill.field.parcel-weight': 'Weight',
  'bill.field.parcel-price': 'Amount (LAK)',
  'bill.field.receipt': 'Receipt date',
  'bill.field.shippingDate': 'Shipping date',
};
const parcel = {
  'parcel.title': 'Parcel',

  'parcel.field.no': 'No',
  'parcel.field.create': 'Create Payment',
  'parcel.field.track': 'Track No 1.',
  'parcel.field.zto-track': 'ZTO Track No.',
  'parcel.field.bill': 'Bill No.',
  'parcel.field.payNo': 'Payment No.',
  'parcel.field.name': 'Name',
  'parcel.field.phone': 'Phone',
  'parcel.field.weight': 'Weight',
  'parcel.field.costPrice': 'Cost price',
  'parcel.field.address': 'Address',
  'parcel.field.amount': 'Amount (LAK)',
  'parcel.field.import': 'Import date',
  'parcel.field.receiptDate': 'Receipt date',
  'parcel.field.statusReceipt': 'Status (receipt)',
  'parcel.field.statusPayment': 'Payment Status',
  'parcel.field.datePayment': 'Payment date',
  'parcel.field.dateShipping': 'Shipping date',
  'parcel.field.status': 'Status',
  'parcel.field.createAt': 'Create Date',
  'parcel.field.updateAt': 'Update Data',
};

const reportAccounting = {
  'report.account.field.no': 'No',
  'report.account.field.date': 'Date',
  'report.account.field.billNo': 'Bill No',
  'report.account.field.totalAmount': 'Total amount(LAK)',
  'report.account.field.cash': 'Cash',
  'report.account.field.transfer': 'Transfer',
  'report.account.field.aliPay': 'Alipay',
  'report.account.field.weChatPay': 'Wechat Pay',
};

const reportIncome = {
  'report.income.field.no': 'No',
  'report.income.field.date': 'Date',
  'report.income.field.description': 'Description',
  'report.income.field.billNo': 'Bill No',
  'report.income.field.amount': 'Amount',
  'report.income.field.shipping': 'Shipping',
  'report.income.field.topUp': 'Top - Up',
  'report.income.field.expenses': 'Expenses',
  'report.income.field.balance': 'Balance',
};

const reportReturnParcel = {
  'report.returnParcel.field.no': 'No',
  'report.returnParcel.field.track': 'Track No.',
  'report.returnParcel.field.date': 'Return date',
  'report.returnParcel.field.deli-car': 'Delivery car no.',
  'report.returnParcel.field.deli-person': 'Delivery Person',
};

const currency = {
  'currency.title': 'Currency',
  'currency.field.add': 'Add',
  'currency.field.create': 'Create Currency',

  'currency.field.info': 'Currency Information',
  'currency.field.rate': 'Exchange rate (CNY)',

  'currency.field.no': 'No',
  'currency.field.date': 'Date',
  'currency.field.lak': '1 LAK/CNY',
  'currency.field.updateAt': 'Update Data',
};

const customerLevel = {
  'customerLevel.title': 'Customer Level',
  'customerLevel.field.add': 'Add',
  'customerLevel.field.create': 'Create Customer Level',

  'customerLevel.field.info': 'Customer Level Information',
  'customerLevel.field.rate': 'Exchange rate (CNY)',
  'customerLevel.field.levelName': 'Level Name',
  'customerLevel.field.description': 'Description',
  'customerLevel.field.rateKip': 'Rate - Kip (LAK)',

  'customerLevel.field.no': 'No',
  'customerLevel.field.date': 'Date',
  'customerLevel.field.lak': '1 LAK/CNY',
  'customerLevel.field.updateAt': 'Update Data',
};

const customer = {
  'customer.title': 'Customer',
  'customer.field.add': 'Add',
  'customer.field.create': 'Create Customer',

  'customer.field.info': 'Customer Level Information',
  'customer.field.levelName': 'Level Name',
  'customer.field.description': 'Description',
  'customer.field.customerLevel': 'Customer Level',
  'customer.field.rateKip': 'Rate - Kip (LAK)',
  'customer.field.address': 'address',

  'customer.field.no': 'No',
  'customer.field.name': 'Name',
  'customer.field.phone': 'Phone',
  'customer.field.level': 'Level',
  'customer.field.rate': 'Rate',
  'customer.field.verify': 'Verify',
  'customer.field.status': 'Status',
  'customer.field.createAt': 'Create Date',
  'customer.field.updateAt': 'Update Data',
};

const department = {
  'department.title': 'Department',
  'department.field.add': 'Add',
  'department.field.create': 'Create Department',

  'department.field.info': 'Department Information',
  'department.field.departmentName': 'Department Name',
  'department.field.description': 'Description',
  'department.field.customerLevel': 'Department',
  'department.field.rateKip': 'Rate - Kip (LAK)',
  'department.field.address': 'address',

  'department.field.no': 'No',
  'department.field.name': 'Department Name',
  'department.field.phone': 'Phone',
  'department.field.level': 'Level',
  'department.field.rate': 'Rate',
  'department.field.verify': 'Verify',
  'department.field.status': 'Status',
  'department.field.createAt': 'Create Date',
  'department.field.updateAt': 'Update Data',
};

const user = {
  'user.title': 'User',
  'user.field.add': 'Add',
  'user.field.create': 'Create User',

  'user.field.info': 'User Information',
  'user.field.departmentName': 'User Name',
  'user.field.description': 'Description',
  'user.field.customerLevel': 'User',
  'user.field.rateKip': 'Rate - Kip (LAK)',
  'user.field.address': 'address',

  'user.field.no': 'No',
  'user.field.name': 'Name',
  'user.field.phone': 'Phone',
  'user.field.email': 'Email',
  'user.field.password': 'Password',
  'user.field.department': 'Department',
  'user.field.role': 'Role',
  'user.field.status': 'Status',
  'user.field.createAt': 'Create Date',
  'user.field.updateAt': 'Update Data',
};

const loMessages = {
  ...user,
  ...department,
  ...customer,
  ...currency,
  ...customerLevel,
  ...reportReturnParcel,
  ...reportIncome,
  ...reportAccounting,
  ...parcel,
  ...bill,
  ...payment,
  ...common,
  ...dashboards,
  'menu.dashboards': 'Dashboards',
  'menu.import-data': 'Import data',
  'menu.import-returnParcel': 'Report - Return Parcel',
  'menu.import-accounting': 'Report - Accounting',
  'menu.import-income': 'Report - Income / Expenses',
  'menu.parcel': 'Parcel',
  'menu.user': 'User',
  'menu.currency': 'Currency',
  'menu.customerLevel': 'Customer Level',
  'menu.customer': 'Customer',
  'menu.bill': 'Bill',
  'menu.payment': 'Payment',
  'menu.department': 'Department',
  'menu.incomeExpenses': 'Income / Expenses',
  'menu.report': 'Report',
  'menu.accounting': 'Accounting',
  'menu.incomeExpenses-report': 'Income / Expenses',
  'menu.returnParcel': 'Return Parcel',
  'menu.setting': 'Setting',
  'menu.setting-currency': 'Currency',
  'menu.setting-customerLevel': 'Customer Level',
  'menu.setting-customer': 'Customer',
  'menu.setting-role': 'Role & permission',
  'menu.setting-department': 'Department',
  'menu.setting-user': 'User',
  'menu.evaluation': 'Evaluation',
  'menu.evaluation-self': 'Self Evaluation',
  'menu.evaluation-emp': 'Evaluation Employees',
  'menu.evaluation-result': 'Evaluation results',
  'menu.settings': 'Settings',
  'menu.profile': 'Profile',
  'menu.default': 'Default',
  'menu.visual': 'Visual',
  'menu.analytic': 'Analytic',
  'menu.apps': 'Apps',
  'menu.calendar': 'Calendar',
  'menu.chat': 'Chat',
  'menu.contacts': 'Contacts',
  'menu.mailbox': 'Mailbox',
  'menu.tasks': 'Tasks',
  'menu.pages': 'Pages',
  'menu.authentication': 'Authentication',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.reset-password': 'Reset Password',
  'menu.blog': 'Blog',
  'menu.home': 'Home',
  'menu.grid': 'Grid',
  'menu.list': 'List',
  'menu.detail': 'Detail',
  'menu.miscellaneous': 'Miscellaneous',
  'menu.faq': 'Faq',
  'menu.knowledge-base': 'Knowledge Base',
  'menu.error': 'Error',
  'menu.coming-soon': 'Coming Soon',
  'menu.pricing': 'Pricing',
  'menu.search': 'Search',
  'menu.mailing': 'Mailing',
  'menu.empty': 'Empty',
  'menu.portfolio': 'Portfolio',
  'menu.standard': 'Standard',
  'menu.blocks': 'Blocks',
  'menu.images': 'Images',
  'menu.tabular-data': 'Tabular Data',
  'menu.thumbnails': 'Thumbnails',
  'menu.cta': 'Cta',
  'menu.gallery': 'Gallery',
  'menu.stats': 'Stats',
  'menu.steps': 'Steps',
  'menu.details': 'Details',
  'menu.interface': 'Interface',
  'menu.components': 'Components',
  'menu.accordion': 'Accordion',
  'menu.alerts': 'Alerts',
  'menu.badge': 'Badge',
  'menu.breadcrumb': 'Breadcrumb',
  'menu.buttons': 'Buttons',
  'menu.button-group': 'Button Group',
  'menu.card': 'Card',
  'menu.close-button': 'Close Button',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.list-group': 'List Group',
  'menu.modal': 'Modal',
  'menu.navs': 'Navs',
  'menu.offcanvas': 'Offcanvas',
  'menu.pagination': 'Pagination',
  'menu.popovers': 'Popovers',
  'menu.progress': 'Progress',
  'menu.spinners': 'Spinners',
  'menu.toasts': 'Toasts',
  'menu.tooltips': 'Tooltips',
  'menu.forms': 'Forms',
  'menu.layouts': 'Layouts',
  'menu.validation': 'Validation',
  'menu.wizard': 'Wizard',
  'menu.input-group': 'Input Group',
  'menu.input-mask': 'Input Mask',
  'menu.generic-forms': 'Generic Forms',
  'menu.controls': 'Controls',
  'menu.autocomplete': 'Autocomplete',
  'menu.checkbox-radio': 'Checkbox-Radio',
  'menu.date-picker': 'Date Picker',
  'menu.dropzone': 'Dropzone',
  'menu.editor': 'Editor',
  'menu.input-spinner': 'Input Spinner',
  'menu.rating': 'Rating',
  'menu.select': 'Select',
  'menu.slider': 'Slider',
  'menu.tags': 'Tags',
  'menu.time-picker': 'Time Picker',
  'menu.plugins': 'Plugins',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.clamp': 'Clamp',
  'menu.context-menu': 'Context Menu',
  'menu.datatables': 'Datatables',
  'menu.editable-rows': 'Editable Rows',
  'menu.editable-boxed': 'Editable Boxed',
  'menu.server-side': 'Server Side',
  'menu.boxed-variations': 'Boxed Variations',
  'menu.lightbox': 'Lightbox',
  'menu.maps': 'Maps',
  'menu.notification': 'Notification',
  'menu.players': 'Players',
  'menu.scrollbar': 'Scrollbar',
  'menu.shortcuts': 'Shortcuts',
  'menu.sortable': 'Sortable',
  'menu.content': 'Content',
  'menu.icons': 'Icons',
  'menu.cs-line-icons': 'CS Line Icons',
  'menu.cs-interface-icons': 'CS Interface Icons',
  'menu.bootstrap-icons': 'Bootstrap Icons',
  'menu.tables': 'Tables',
  'menu.typography': 'Typography',
  'menu.menu': 'Menu',
  'menu.horizontal': 'Horizontal',
  'menu.vertical': 'Vertical',
  'menu.vertical-hidden': 'Vertical Hidden',
  'menu.vertical-no-hidden': 'Vertical No Hidden',
  'menu.mobile-only': 'Mobile Only',
  'menu.sidebar': 'Sidebar',
  'menu.Docs': 'Docs',
  'menu.connections': 'Connections',
  'menu.bookmarks': 'Bookmarks',
  'menu.requests': 'Requests',
  'menu.account': 'Account',
  'menu.password': 'Password',
  'menu.devices': 'Devices',
  'menu.notifications': 'Notifications',
  'menu.email': 'Email',
  'menu.sms': 'SMS',
  'menu.downloads': 'Downloads',
  'menu.documents': 'Documents',
  'menu.videos': 'Videos',
  'menu.dashboard': 'Dashboard',
  'menu.products': 'Products',
  'menu.orders': 'Orders',
  'menu.customers': 'Customers',
  'menu.storefront': 'Storefront',
  'menu.filters': 'Filters',
  'menu.categories': 'Categories',
  'menu.cart': 'Cart',
  'menu.checkout': 'Checkout',
  'menu.invoice': 'Invoice',
  'menu.shipping': 'Shipping',
  'menu.discount': 'Discount',
  'menu.general': 'General',

  'menu.upgrade': 'Upgrade',
  'menu.community': 'Community',
  'menu.community-list': 'Community List',
  'menu.getting-started': 'Getting Started',
  'menu.analysis': 'Analysis',
  'menu.services': 'Services',
  'menu.database': 'Database',
  'menu.database-add': 'New Database',
  'menu.database-detail': 'Database Detail',
  'menu.storage': 'Storage',
  'menu.hosting': 'Hosting',
  'menu.users': 'Users',
  'menu.billing': 'Billing',
  'menu.security': 'Security',
  'menu.support': 'Support',
  'menu.docs': 'Docs',
  'menu.docsdetail': 'Docs Detail',
  'menu.tickets': 'Tickets',
  'menu.tickets-detail': 'Teicket Detail',

  'menu.elearning': 'Elearning',
  'menu.school': 'School',
  'menu.courses': 'Courses',
  'menu.explore': 'Explore',
  'menu.quiz': 'Quiz',
  'menu.result': 'Result',
  'menu.paths': 'Paths',
  'menu.instructor': 'Instructor',
  'menu.misc': 'Miscellaneous',
  'menu.player': 'Player',
  'menu.material': 'Material',
  'menu.syllabus': 'Syllabus',
};
export default loMessages;
